export default __webpack_public_path__ + "static/media/FSEmericWeb-SemiBold.fca9a664.woff2";